<template>
  <div class="repo-notice">
    <h2 class="repo-notice__title">项目回购通知书详情</h2>
    <div class="repo-notice__content">
      <!-- tab -->
      <el-radio-group v-model="tabCurrent">
        <el-radio-button class="repo-notice__tab"
                         label="1">项目信息</el-radio-button>
        <el-radio-button class="repo-notice__tab"
                         label="2">通知书</el-radio-button>
      </el-radio-group>

      <!-- tab内容 -->
      <div class="repo-notice__tab-content">
        <!-- 项目信息 -->
        <div v-show="tabCurrent==1"
             class="repo-notice__tab-1">
          <!--  基本信息 -->
          <div>
            <div class="repo-notice__sub-title-wrap">
              <span class="repo-notice__sub-title-no">1</span>
              <span class="repo-notice__sub-title">基本信息</span>
            </div>
            <table class="repo-notice__base-info">
              <tr>
                <th>产品名称:</th>
                <td>{{loanItemRepo.baseProductName}}</td>
                <th>买家:</th>
                <td>{{loanItemRepo.buyerName}}</td>
              </tr>
              <tr>
                <th>应收账款金额:</th>
                <td>{{loanItemRepo.accountsReceivableAmount | addThousandSign(2)}}</td>
                <th>合同信息:</th>
                <td>{{loanItemRepo.contractCode}}</td>
              </tr>
              <tr>
                <th>已还本金:</th>
                <td>{{loanItemRepo.havePayPrincipal | addThousandSign(2)}}</td>
                <th>已还利息:</th>
                <td>{{loanItemRepo.havePayInterest | addThousandSign(2)}}</td>
              </tr>
              <tr>
                <th>未还本金:</th>
                <td>{{loanItemRepo.principal | addThousandSign(2)}}</td>
                <th>未还利息:</th>
                <td>{{loanItemRepo.interest | addThousandSign(2) }}</td>
              </tr>
              <tr>
                <th>还款到期日:</th>
                <td>{{loanItemRepo.accountsReceivableEndTimeStr}}</td>
              </tr>
            </table>
          </div>

          <!-- 凭证列表 -->
          <div>
            <div class="repo-notice__sub-title-wrap">
              <span class="repo-notice__sub-title-no">2</span>
              <span class="repo-notice__sub-title">凭证列表</span>
            </div>
            <el-table :data="voucherList"
                      class="repo-notice__voucher_table"
                      style="width: 100%"
                      show-summary
                      :summary-method="getSummaries">

              <el-table-column type="index"
                               width="60"
                               label="序号"
                               align="center"> </el-table-column>
              <el-table-column prop="buyerName"
                               show-overflow-tooltip
                               label="买方"
                               width="130"
                               align="center"> </el-table-column>
              <el-table-column prop="customerName"
                               show-overflow-tooltip
                               label="卖方"
                               width="130"
                               align="center"> </el-table-column>
              <el-table-column prop="contractNumber"
                               show-overflow-tooltip
                               label="商务合同号"
                               width="80"
                               align="center"></el-table-column>
              <el-table-column prop="lnvoiceNumber"
                               show-overflow-tooltip
                               label="发票号"
                               width="80"
                               align="center"> </el-table-column>
              <el-table-column label="发票/合同金额"
                               show-overflow-tooltip
                               width="90"
                               align="center"
                               prop="contractAmount">
                <template slot-scope="scope">{{scope.row.contractAmount | addThousandSign(2)}}</template>
              </el-table-column>
              <el-table-column label="应收账款金额"
                               show-overflow-tooltip
                               width="90"
                               align="center"
                               prop="accountsReceivableAmount">
                <template slot-scope="scope">{{scope.row.accountsReceivableAmount | addThousandSign(2)}}</template>
              </el-table-column>
              <el-table-column label="已付金额"
                               show-overflow-tooltip
                               width="90"
                               align="center"
                               prop="alreadyPaidAmount">
                <template slot-scope="scope">{{scope.row.alreadyPaidAmount | addThousandSign(2)}}</template>
              </el-table-column>

              <el-table-column label="操作"
                               align="center">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="primary"
                             @click="$router.push(`/FrontVoucherInfo_bl/${scope.row.frontApplyId}/${scope.row.voucherInfoId}`)"
                             class="btn operation">查看</el-button>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>

        <!-- 回执pdf -->
        <iframe class="repo-notice__delivery-pdf"
                v-show="tabCurrent==2"
                :src="deliveryPdfUrl"></iframe>
      </div>
      <div class="repo-notice__bottom">
        <el-button type="primary"
                   class="repo-notice__bottom-btn"
                   style="margin-right:40px"
                   @click="goBack()">返回</el-button>
        <el-button type="danger"
                   v-if="confirmStatus === 0"
                   class="repo-notice__bottom-btn"
                   @click="confirmOpt()">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '../../vuex/types';
import { mapGetters } from 'vuex';
import api from '../../api/repoNotice';
export default {
  name: 'TransferAdviceDetail',
  data () {
    return {
      tabCurrent: '1',
      noticeId: null,
      loanItemRepo: {
        voucherInfoId: '',
        baseProductName: '',
        buyerName: '',
        accountsReceivableAmount: '',
        contractCode: '',
        havePayPrincipal: 0,
        havePayInterest: 0,
        principal: 0,
        interest: 0,
        accountsReceivableEndTimeStr: '',
        frontApplyId: ''
      },
      confirmStatus: '',
      voucherList: [],
      sumPropertyList: [
        'contractAmount',
        'accountsReceivableAmount',
        'alreadyPaidAmount'
      ] // 凭证列表合计字段
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    }),
    pdfPath () {
      return './static/js/pdf/web/viewer.html?file=';
    },
    deliveryPdfUrl () {
      const url = `${
        this.ajaxBaseUrl
      }/loanform/blitem/blloanitemreponotice/readRepoNoticePdf.ht?noticeId=${this.noticeId}`;
      return this.pdfPath + encodeURIComponent(url);
    }
  },
  methods: {
    getData (id) {
      api.getRepoNoticeDetail(id).then((resp) => {
        const respData = resp.data;
        if (respData.rspcode === 1) {
          const data = respData.data;
          this.loanItemRepo = data.loanItemRepo;
          this.voucherList = data.voucherList;
          this.noticeId = data.noticeId;
          this.confirmStatus = data.confirmStatus;
        }
      });
    },
    // 返回
    goBack () {
      this.$router.push('/personalCenter/repoNotice/list');
    },
    // 确认
    async confirmOpt () {
      const that = this;
      const option = await this.$confirm('是否确认回购通知书?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).catch(() => {
        that.$msg({ message: '操作取消', type: 'info' });
        return;
      });

      if (option !== 'confirm') return;
      console.log('this.noticeId');
      console.log(this.noticeId);
      api
        .confirm(this.noticeId)
        .then((resp) => {
          const respData = resp.data;
          if (respData.rspcode === 1) {
            this.confirmStatus = respData.data.confirmStatus;
            this.$msg({ message: '操作成功', type: 'success' });
          } else {
            this.$msg({ message: respData.rspdesc, type: 'warning' });
          }
        })
        .catch(() => {
          this.$msg({ message: '操作失败', type: 'error' });
        });
    },
    // 凭证列表合计
    getSummaries (param) {
      const _this = this;
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]));
        const isSumProperty =
          _this.sumPropertyList.indexOf(column.property) > -1; // 判断是否合计字段
        if (!values.every(value => isNaN(value)) && isSumProperty) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index]
            .toFixed(2)
            .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
        } else {
          sums[index] = '';
        }
      });
      sums[0] = '合计:';
      return sums;
    }
  },
  mounted () {
    const id = this.$route.params.id;
    this.getData(id);
  }
};
</script>

<style>
/* 标题 */
.repo-notice__title {
  font-size: 22px;
  font-weight: bolder;
  height: 60px;
  line-height: 60px;
  margin-left: 20px;
}

/* 内容区域 */
.repo-notice__content {
  box-sizing: border-box;
  background-color: #fff;
  width: 900px;
  box-sizing: border-box;
  margin-left: 20px;
  padding: 30px 22px 50px 20px;
}

/* tab */
.repo-notice__tab .el-radio-button__inner {
  width: 120px;
  height: 38px;
  padding: 10px;
}
/* tab内容区域 */
.repo-notice__tab-content {
  width: 850px;
  margin-top: 28px;
}

/* tab-1的子标题 */
.repo-notice__sub-title-wrap {
  height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.repo-notice__sub-title-no {
  display: inline-block;
  width: 17px;
  height: 17px;
  line-height: 17px;
  border-radius: 50%;
  color: #fff;
  background-color: red;
  font-size: 14px;
  text-align: center;
  margin-right: 9px;
}

.repo-notice__sub-title {
  font-size: 16px;
}

/* 基本信息表格 */
.repo-notice__base-info {
  border-spacing: 0 1px;
  margin-bottom: 31px;
}

.repo-notice__base-info th,
.repo-notice__base-info td {
  height: 38px;
  font-size: 14px;
}

.repo-notice__base-info th {
  box-sizing: border-box;
  background-color: #fffaf4;
  width: 117px;
  text-align: right;
  padding-right: 12px;
  border: 1px solid #ffede2;
  font-weight: 500;
}

.repo-notice__base-info td {
  background-color: #fff;
  width: 255px;
  padding-left: 15px;
  border: 1px solid #f2f2f2;
}

/* 凭证列表 */
.repo-notice__voucher_table {
  border: 1px solid #ffede2;
}
.repo-notice__voucher_table th {
  background-color: #fff4f4;
  color: #000;
  border-bottom: 1px solid #ffede2;
  font-weight: 500;
}
.repo-notice__voucher_table .btn {
  width: 42px;
  height: 21px;
  padding: 1px;
}

/* 回执pdf */
.repo-notice__delivery-pdf {
  width: 850px;
  height: 500px;
}

/* 底部 */
.repo-notice__bottom {
  margin-top: 35px;
  text-align: center;
  width: 850px;
}

.repo-notice__bottom-btn {
  width: 90px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// RepoNoticeDetail.vue?f9511778